<template>
  <div>
    <!-- Header -->
    <div class="header-popup">
      <img
        v-if="dataDetail.trigger.type === 'form'"
        :src="require('@/assets/automation/data_manager.svg')"
        width="26"
        height="26"
        class="mr-2"
      >
      <img
        v-else-if="dataDetail.trigger.type === 'event'"
        :src="require('@/assets/automation/event.svg')"
        width="26"
        height="26"
        class="mr-2"
      >
      <img
        v-else-if="dataDetail.trigger.type === 'function'"
        :src="require('@/assets/automation/function.svg')"
        width="26"
        height="26"
        class="mr-2"
      >
      <img
        v-else-if="dataDetail.trigger.type === 'job' ||
        dataDetail.trigger.type === 'dedicated_job'"
        :src="require('@/assets/automation/job.svg')"
        width="26"
        height="26"
        class="mr-2"
      >
      <img
        v-else
        :src="require('@/assets/automation/api.svg')"
        width="26"
        height="26"
        class="mr-2"
      >
      <div class="header-text">{{ dataDetail.name }}</div>
    </div>

    <!-- Tab -->
    <div class="tabs">
      <div
        v-for="tab in tabs"
        :key="tab.key"
        :class="{
          'active': tab.key === tabSelected,
          'disabled': !tab.active
        }"
        class="tab-list"
        @click="handleClickTab(tab)"
      >
        {{ tab.label }}
      </div>
    </div>

    <div class="popup-content">
      <j-popup-detail-tab
        v-if="tabSelected === 'detail'"
        :data-detail="dataDetail"
      />
    </div>
  </div>
</template>

<script>
import jPopupDetailTab from '@/views/visual-programming/popup/partials/jPopupDetailTab';

export default {
  components: {
    jPopupDetailTab,
  },

  props: {
    dataDetail: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      tabs: [
        { key: 'detail', label: 'Details', active: true },
        { key: 'activity', label: 'Activity', active: false },
      ],
      tabSelected: 'detail',
    };
  },

  methods: {
    handleClickTab(tab) {
      if (tab.active) this.tabSelected = tab.key;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-popup {
  display: flex;
  margin-bottom: 10px;

  .header-text {
    width: 80%;
    @include font('Poppins-Semibold', 14px, $black);
    line-height: 22px;
    margin-bottom: 0;
  }
}

.tabs {
  width: 100%;
  display: flex;
  border-bottom: 1px solid $gray-border;
  margin-top: 14px;

  .tab-list {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    @include font('Poppins-Semibold', 14px, $black-5);
    transition: all 0.3s ease-in-out;
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;
    cursor: pointer;

    &.active {
      color: $primary;
      border-color: $primary;
    }
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}

.popup-content {
  max-height: calc(100vh - 240px);
  margin-top: 10px;
  margin-left: -20px;
  margin-right: -20px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 5px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/visual-programming/popup/jPopupDetailVp.vue